/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-06-05 09:41:06
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-06-05 15:01:53
 * @FilePath: \crm-product\src\views\performanceCalculation\views\import_statement\network_performance_import\table\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import Form from '../form';

export default {
  extends: TablePage,
  components: {
    Form,
  },
  name: 'network_performance_import',
  data() {
    return {

    };
  },
  created() {
    this.getConfigList('main-list');
  },

  methods: {
    modalClick({
      val,
      row,
    }) {
      if (val.code === 'add' || val.code === 'edit' || val.code === 'view') {
        this.formConfig = {
          ...val,
          row,
        };
        this.modalConfig.width = '70%';
        this.modalConfig.title = val.name;
        this.openModal();
      } else if (val.code === 'enable') {
        if (!this.selection.length) {
          this.$message('请至少选择一条数据！');
          return false;
        }
        request.post('/mdm/performancestoretarget/enable', {
          ids: this.selection,
        }).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.getList();
            this.clearSelection();
          }
        });
      } else if (val.code === 'disable') {
        if (!this.selection.length) {
          this.$message('请至少选择一条数据！');
          return false;
        }
        request.post('/mdm/performancestoretarget/disable', {
          ids: this.selection,
        }).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.getList();
            this.clearSelection();
          }
        });
      }
    },
  },
};
